import { createSlice } from '@reduxjs/toolkit';
import { IFilterItem } from '../interfaces';

interface IState {
    query: string;
    filtered: IFilterItem[];
    selectedItemIndex: number;
    isOpened: boolean;
}

/**
 * initial state
 */
const initialState: IState = {
    query: '',
    selectedItemIndex: -1,
    filtered: [],
    isOpened: false,
};

const rootSlice = createSlice({
    name: 'root',
    initialState,
    reducers: {

        main(state, action) {
            return {
                ...state,
                ...action.payload,
            }
        },
    }
});

export default rootSlice;